import { eachOfLimitInOrder } from './eachOfLimitInOrder.js';

const async = {
    eachOfLimitInOrder
};

export { async };
